import ReactDOM from "react-dom/client";
import dayjsDuration from "dayjs/plugin/duration";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { enableMapSet } from "immer";
// import { Toast } from "@heroui/react";
// import { addToast } from "@heroui/react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { merge } from "lodash-es";
import { Error as ConstError } from "$/api_out/http_checkin/const/const_err";
import App, { globalRoute } from "./pages/App";
import { subscribeApiErr } from "$/utils/webapi";
import zhCN_local from "./locales/zh-CN.json";
import zhTW_local from "./locales/zh-TW.json";
import ja_local from "./locales/ja.json";
import en_local from "./locales/en.json";
import ko_local from "./locales/ko.json";
import careerConfig from "$/open_dict/career.json";
import countryConfig from "$/open_dict/country.json";
import documentConfig from "$/open_dict/document.json";
import { transformJsonToI18n } from "$/utils/transformJsonToI18n";
import { polyfillCountryFlagEmojis } from "./utils/polyfillCountryFlagEmojis";
import { I18nNamespace } from "./const/i18nNamespace";
import "./main.css";
/**
 * 测试环境用
 */
// import VConsole from "vconsole";

// new VConsole();

// 手动触发构建

export type CountryCodeValue = keyof typeof countryConfig;
export type DocumentCodeValue = keyof typeof documentConfig;
export type CareerValue = keyof typeof careerConfig;

polyfillCountryFlagEmojis();
const careeri18n = transformJsonToI18n(careerConfig, I18nNamespace.CAREER);
const countryi18n = transformJsonToI18n(countryConfig, I18nNamespace.COUNTRY);
const documenti18n = transformJsonToI18n(
  documentConfig,
  I18nNamespace.DOCUMENT,
);

const resources = merge(
  {
    en: en_local,
    "zh-CN": zhCN_local,
    "zh-TW": zhTW_local,
    ja: ja_local,
    ko: ko_local,
  },
  careeri18n,
  countryi18n,
  documenti18n,
);

console.info("career i18n:", resources);

i18n
  .use(LanguageDetector) // 可选：自动检测 navigator.language
  .use(initReactI18next) // React 集成
  .init({
    // 预期支持语言列表（可用于白名单）
    // supportedLngs: ["en", "zh-CN", "zh-TW", "ja"],
    // 当检测结果不在 supportedLngs 或资源缺失时回退
    fallbackLng: "en",

    // 当检测到 'zh-CN' 或 'en-US' 时的降级策略：
    // 默认 i18next 会尝试: 'zh-CN' -> 'zh' -> fallbackLng
    // 如果你只想用语言代码不关心地区，可设置 load: 'languageOnly'
    // load: "languageOnly",

    // 资源
    resources,

    ns: ["common"],
    defaultNS: "common",

    interpolation: {
      escapeValue: false,
    },

    // 可打开调试方便确认降级
    debug: true,
  })
  .catch((err) => {
    console.error("i18n init failed:", err);
  });

// 强制使用日语进行测试
// void i18n.changeLanguage("zh-CN");

enableMapSet();

dayjs.extend(dayjsDuration);
dayjs.extend(utc);
dayjs.extend(timezone);

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);

subscribeApiErr((err) => {
  if (err.code === ConstError.CannotCheckIn) {
    // a在录入时，b提交了，需要刷新状态
    window.location.reload();
  }
  // 订单被取消，或者入口关闭了
  else if (err.code === ConstError.NoPermission) {
    globalRoute.navigate?.("/404", { replace: true });
  }
  // 其他业务根据code自行处理抛错
});

export default App;
